import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction-to-features"
    }}>{`Introduction to Features`}</h1>
    <h2 {...{
      "id": "tax-management"
    }}>{`Tax Management`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`Tax`}</inlineCode>{` menu you will get the Tax list and you can add, remove or modify Tax from there.`}</p>
    <p><img alt="super-admin-tax-list" src={require("../images/revamp/super-admin-tax-list.png")} /></p>
    <p>{`Like any other company, Chawkbazar must pay taxes to the government. The government uses taxes as a means of raising money to support public infrastructure and services like roads, schools, and hospitals.`}</p>
    <p>{`Chawkbazar is an online marketplace that links buyers and sellers so that anyone may purchase and sell goods. The merchant makes money when a consumer uses Chawkbazar to buy something, and as a result, is obligated to pay taxes on that money.`}</p>
    <blockquote>
      <p parentName="blockquote">{` Tax in Super Admin perspective`}</p>
    </blockquote>
    <p>{`In `}<inlineCode parentName="p">{`Tax`}</inlineCode>{` menu you will get the Tax list and you can add, remove or modify Tax from there. `}</p>
    <p><img alt="super-admin-tax-list" src={require("../images/revamp/super-admin-tax-list.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`To add a new tax, `}</p>
    </blockquote>
    <ul>
      <li parentName="ul">{`Super administrator must now specify its name and value. The list of taxes will display the newly established tax.`}</li>
      <li parentName="ul">{`He may access the settings from the admin dashboard and configure the tax he wants to enable.`}</li>
    </ul>
    <p><img alt="super-admin-tax-form" src={require("../images/revamp/super-admin-tax-form.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{` Tax in Customer perspective`}</p>
    </blockquote>
    <p>{`When a consumer adds items to his cart and checks out, he may discover that the tax has been added to the `}<inlineCode parentName="p">{`subtotal`}</inlineCode>{`. In order to place an order, the consumer must now click `}<inlineCode parentName="p">{`place order`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "withdrawal-management"
    }}>{`Withdrawal Management`}</h2>
    <p>{`The procedure by which a seller can move their profits or balance from the Chawkbazar platform to their own bank account or another payment method is known as a withdrawal mechanism in Chawkbazar.`}</p>
    <p>{`In most withdrawal systems, the seller must ask to remove money from their account balance. With the seller's identification being confirmed, the platform may impose conditions regarding the minimum withdrawal amounts or withdrawal costs. Then based on that request Super admin will dispatch the withdrawal request to vendor's desired payment system.The payment method and the platform's rules will determine how long this procedure will take, which might be several business days.`}</p>
    <p>{`The ability for sellers to obtain their revenues and use them for either personal or professional objectives makes withdrawal mechanisms an essential component.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Withdrawal Lists will be here.`}</p>
    </blockquote>
    <p><img alt="super-admin-withdrawal-list" src={require("../images/revamp/super-admin-withdrawal-list.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Withdrawal details`}</p>
    </blockquote>
    <p><img alt="super-admin-withdrawal-form" src={require("../images/revamp/super-admin-withdrawal-form.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{` Withdrawal in Super Admin perspective`}</p>
    </blockquote>
    <p>{`Requested Withdrawals will show up in the "recent Withdrawals" section of the admin dashboard. The administrator can use the action function and change the withdrawal request's status from pending to approved by clicking on `}<inlineCode parentName="p">{`change status`}</inlineCode>{` button.`}</p>
    <blockquote>
      <p parentName="blockquote">{` Withdrawal in Vendor perspective`}</p>
    </blockquote>
    <p>{`The store owner must first log in, then from the dashboard, we must locate "my shops". The seller's shop is where he may locate withdrawal options. The options below will be displayed if he visits his own store.`}</p>
    <p>{`The seller may submit withdrawal requests under the withdrawals area. The seller can select `}<inlineCode parentName="p">{`request withdrawals`}</inlineCode>{` and enter a request for a lesser quantity than what is now available.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Withdrawal form for Vendor`}</p>
    </blockquote>
    <p><img alt="vendor-withdrawal-form" src={require("../images/revamp/vendor-withdrawal-form.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      